import { Component, OnInit, OnDestroy } from '@angular/core'

import { UserService } from '../../users/shared/user.service'
import { AuthService } from '../../auth/auth.service'

import { Subscription } from 'rxjs/Subscription'

@Component({
  selector: 'cm-toolbar-main-navigation',
  templateUrl: './toolbar-main-navigation.component.html',
  styleUrls: ['./toolbar-main-navigation.component.css']
})
export class ToolbarMainNavigationComponent implements OnInit, OnDestroy {

  public showNewMessageHint = false

  private subscription: Subscription

  constructor(private userService: UserService,
    private authService: AuthService) { }

  ngOnInit() {
    const uid = this.authService.currentUser.uid
    this.subscription = this.userService.getNotificationCount(uid)
      .subscribe((count: number) => {
        this.showNewMessageHint = count > 0
      })
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-main-navigation/toolbar-main-navigation.component.ts